import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react';
import {getInstance} from '../api/baseapi'
import {
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
} from "../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../components/useDynamic/Button_DynamicStyle";
import {
  alertKeySpaceBar,
  alertKeyLangTH,
  alertEnterEmail,
  alertIncorrectEmail,
  alertSendEamil,
  alertError
} from "../components/alertValid/AlertValid.js"

function ForgotPassword() {
  useButtonDynamicStyles(
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
);
  const navigate = useNavigate();
  const [inputEmail, setInputEmail] = useState("");
  const [txtSmall, setTxtSmall] = useState("*ระบบจะส่งข้อความไปที่อีเมลเพื่อให้ท่านตั้งรหัสผ่านใหม่");

  function navigateToBack(page){
    navigate(page);
  }

  const handleEmailChange = (e) => {
    setInputEmail(e.target.value);
  };

  const handleInputChkThai = async (event) => {
    const thaiCharacterRegex = /[\u0E00-\u0E7F]/; // Thai character Unicode range
  
    if (event.target.value.includes(' ')) {
      event.target.value = event.target.value.replace(/\s/g, ''); // Remove spaces
      await alertKeySpaceBar();
      return;
    }
  
    if (thaiCharacterRegex.test(event.target.value)) {
      event.target.value = ""; // Clear input if it contains Thai characters
      await alertKeyLangTH();
      return;
    }
  };

  const validateUserPass = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!inputEmail) {
      await alertEnterEmail();
      return false;
    }
    if (!emailRegex.test(inputEmail)) {
      await alertIncorrectEmail();
      return false;
    }
    return true;
  };

  async function handleClickCF(){  
    if (validateUserPass()) {
      await sendForgotPass()
    }
  }

  async function sendForgotPass(){
    try {
      const service = getInstance()
          const response = await service.post(`/api/auth/send-forgotpw`,
        {
          "email": inputEmail
        })
      
        if(response.data.status == 'success'){
          setTxtSmall("*ระบบจะส่งข้อความไปที่อีเมลเพื่อให้ท่านตั้งรหัสผ่านใหม่");
          await alertSendEamil();
        }
        else{
          setTxtSmall("ไม่พบอีเมลในระบบ");
        }
    } catch (error) {

      if(error.response.status == 404){
        
        setTxtSmall("*ไม่พบอีเมลในระบบ");
      }
      else{
        await alertError();
      }
        
      }
    }

  return (
    <div id='forgotPW'>
        <div className="container-fluid height100">
          <div className="row justify-content-center height100">
            <div className="col-12 flex-direction login02">
              <div className="card-login">
                <div className="row">
                  <div className='col-12 d-flex justify-content-center'>
                      <img src="assets/icons/ic-fg-pass.png" className="ic-fg-pass" alt="" />
                  </div>
                  <div className="col-12 mt-3 mb-3 d-flex justify-content-center">
                      <label className="fontReg font-size05 line-height03 font-weight-bold colorBlack01">
                          FORGOT PASSWORD
                      </label>
                  </div>
                  <div className="col-12 d-flex justify-content-center">
                      <label className="font-size01 fontLight line-height02 colorBlack01 mb-0 text-center">
                          Please fill in the username to reset the password.
                      </label>
                  </div>
                  <div className="col-12 d-flex justify-content-center">
                      <label className="font-size01 fontLight line-height02 colorBlack01 mb-0 text-center">
                          A new password will send to the email that registered in the system.
                      </label>
                  </div>
                  <div className="col-12 mt-3 d-flex justify-content-center">
                      <label className="font-size01 fontLight line-height02 colorBlack01 mb-0 text-center">
                          กรุณากรอกชื่อผู้ใช้เพื่อรีเซ็ตรหัสผ่าน
                      </label>
                  </div>
                  <div className="col-12 d-flex justify-content-center">
                      <label className="font-size01 fontLight line-height02 colorBlack01 text-center">
                          รหัสผ่านใหม่จะถูกส่งไปยังอีเมลที่ลงทะเบียนไว้ในระบบ
                      </label>
                  </div>
                  <div className="col-12 mt-3">
                    <input
                      onInput={handleInputChkThai}
                      value={inputEmail}
                      type="text"
                      className="inp01 fontLight font-size03"
                      id="email"
                      placeholder="email@mail.com"
                      onChange={handleEmailChange}
                    />
                  </div>
                  <div className="col-12">
                    <small className={`fontLight font-size03 ${txtSmall.includes('ไม่พบ')?'colorRed':'colorGray02'}` }>{txtSmall}</small>
                  </div>
                  <div className="col-12 mt-3 d-flex justify-content-center">
                    <button className="btn btn-lg btn-submit01 fontReg font-size03" onClick={async () => {await handleClickCF()}}>SUBMIT</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default ForgotPassword;